import {
    REQUEST_POPULAR_CARRIERS,
    REQUEST_POPULAR_CARRIERS_SUCCEEDED,
    REQUEST_POPULAR_BCBS_CARRIERS,
    REQUEST_POPULAR_BCBS_CARRIERS_SUCCEEDED,
} from './popularCarriersActions';

const InitialState = {};

export default function popularCarriersByInsuranceTypeReducer(state = InitialState, action) {
    const {
        type,
        payload,
    } = action;

    switch (type) {
        case REQUEST_POPULAR_CARRIERS:
            return {
                ...state,
                [`${payload.insuranceType}-all`]: [],
            };

        case REQUEST_POPULAR_CARRIERS_SUCCEEDED:
            return {
                ...state,
                [`${payload.insuranceType}-all`]: parseCarriers(payload.carriers),
            };

        case REQUEST_POPULAR_BCBS_CARRIERS:
            return {
                ...state,
                [`${payload.insuranceType}-bcbs`]: [],
            };

        case REQUEST_POPULAR_BCBS_CARRIERS_SUCCEEDED:
            return {
                ...state,
                [`${payload.insuranceType}-bcbs`]: parseCarriers(payload.carriers),
            };

        default:
            return state;
    }
}

function parseCarriers(carriers) {
    const parsedCarriers = carriers.map(carrier => ({
        id: carrier[0],
        name: carrier[1],
    }));

    return parsedCarriers;
}
